import { Component, Inject } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose
} from '@angular/material/dialog';
import { Moment } from 'moment';
import { SearchParameter } from '../../../dto/search-parameter';
import { FilterInput } from '../filter-input';
import { CdkScrollable } from '@angular/cdk/scrolling';
import {
  MatFormField,
  MatLabel,
  MatSuffix
} from '@angular/material/form-field';
import {
  MatDateRangeInput,
  MatStartDate,
  MatEndDate,
  MatDatepickerToggle,
  MatDateRangePicker
} from '@angular/material/datepicker';
import { MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatSlider, MatSliderRangeThumb } from '@angular/material/slider';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'pcp-date-filter',
  templateUrl: './date-filter.component.html',
  styleUrls: ['./date-filter.component.scss'],
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    MatFormField,
    MatLabel,
    MatDateRangeInput,
    MatStartDate,
    MatInput,
    FormsModule,
    MatEndDate,
    MatDatepickerToggle,
    MatSuffix,
    MatDateRangePicker,
    MatSlider,
    MatSliderRangeThumb,
    MatDialogActions,
    MatButton,
    MatDialogClose
  ]
})
export class DateFilterComponent {
  constructor(
    public dialogRef: MatDialogRef<DateFilterComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FilterInput<Date>
  ) {}

  getDate(val: number) {
    return new Date(val * 86400000);
  }

  setDate(date: Moment | Date | null | undefined) {
    if (date) {
      return new Date(date.valueOf());
    } else {
      return null;
    }
  }

  getTime(date: Date | Moment | null | undefined) {
    if (date) {
      return date.valueOf() / 86400000;
    }
    return undefined;
  }

  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.dialogRef.close(this.getParameters());
    }
  }

  capitalizeFirstLetter(name: string) {
    return name.charAt(0).toUpperCase() + name.slice(1);
  }

  getParameters() {
    return new SearchParameter(
      'search' + this.capitalizeFirstLetter(this.data.col.name),
      [this.data.from?.toISOString() ?? '', this.data.to?.toISOString() ?? ''],
      this.data.col.type
    );
  }
}
